import { call, put, takeLatest } from 'redux-saga/effects' 
import { VIDEO_CALL_LIST_GET_API_CALL, VIDEO_CALL_LIST_RECEIVE_DATA, VIDEO_CALL_STORE_API_CALL, VIDEO_CALL_DELETE_API_CALL } from '../Actions/actionTypes'
import { videoCallsList, videoCallStore, videoCallDelete } from '../data/API'

import { apiDataStore} from '../Actions/index'

 
function* hitVideoCallStore(body){
    try{
        const response = yield call(videoCallStore, body.payload) 
        response.data.api_type = 'video_call_store' 
        yield put(apiDataStore(response.data)) 
    } catch (e){
        console.log(e)
    }
}
 
function* hitVideoCallDelete(body){
    try{
        const response = yield call(videoCallDelete, body.payload) 
        response.data.api_type = 'video_call_delete' 
        yield put(apiDataStore(response.data)) 
    } catch (e){
        console.log(e)
    }
}


function* hitPatientList(body){
    try{
        const response = yield call(videoCallsList, body.payload) 
        yield put({type:VIDEO_CALL_LIST_RECEIVE_DATA,  payload: response.data.video_call_list}) 
    } catch (e){
        console.log(e)
    }
}
 

export function* watchVideoCallsApi(action) {  
    yield takeLatest(VIDEO_CALL_LIST_GET_API_CALL, hitPatientList) 

    yield takeLatest(VIDEO_CALL_STORE_API_CALL, hitVideoCallStore)  

    yield takeLatest(VIDEO_CALL_DELETE_API_CALL, hitVideoCallDelete)  
}

 